import { render } from "./StorePreviewCollection.vue?vue&type=template&id=04d37855&scoped=true"
import script from "./StorePreviewCollection.vue?vue&type=script&lang=js"
export * from "./StorePreviewCollection.vue?vue&type=script&lang=js"

import "./StorePreviewCollection.vue?vue&type=style&index=0&id=04d37855&lang=css"
import "./StorePreviewCollection.vue?vue&type=style&index=1&id=04d37855&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d37855"]])

export default __exports__